module.exports = __webpack_public_path__ + "static/media/materiały_szkoleniowe_420x240px.cd604dff.png";